export default "__VITE_PUBLIC_ASSET__afb0f722__"